module.exports = __webpack_public_path__ + "static/media/nike-good-luck-returning-that.63fac772.jpg";